let Tabs = mc.widgets.Tabs;
let IconButton = mc.widgets.IconButton;

let Stepper = function (props) {
  let {
    ts,
    bounds,
    periods,
    period,
    autoScale,
    onSetTime,
    onSetPeriod,
    onScale,
    onSearch,
    onEscape
  } = props;

  let disableBack = ts <= bounds[0];

  let disableNext = ts >= bounds[1] - period;

  let rewind = () => onSetTime(bounds[0]);

  let back = () => onSetTime(Math.max(ts - period, bounds[0]));

  let forward = () => onSetTime(Math.min(ts + period, bounds[1]));

  let fastForward = () => onSetTime(bounds[1] - period);

  let label = periods.find((p) => p.value === period).label;

  return (
    <div className="rc-stepper">
      <IconButton
        icon="./img/rc/icon.escape.svg"
        label={tx("back_to_analytics")}
        onPress={onEscape}
        disabled={!onEscape}/>
      <IconButton
        icon="rewind"
        label={tx("start_of_recording")}
        scale={1.1}
        onPress={rewind}
        disabled={disableBack}/>
      <IconButton
        icon="back"
        label={"-" + label}
        scale={1.1}
        onPress={back}
        disabled={disableBack}/>
      <Tabs
        options={periods}
        value={period}
        role="radiogroup"
        onSelect={onSetPeriod}/>
      <IconButton
        icon="forward"
        label={"+" + label}
        scale={1.1}
        onPress={forward}
        disabled={disableNext}/>
      <IconButton
        icon="fast_forward"
        label={tx("end_of_recording")}
        scale={1.1}
        onPress={fastForward}
        disabled={disableNext}/>
      <IconButton
        icon={"./img/rc/icon.autoscale." + autoScale + ".svg"}
        onPress={onScale}
        scale={1.2}
        label={tx("auto_scale")}/>
      <IconButton
        icon="find"
        onPress={onSearch}
        label={tx("search")}/>
    </div>
  );
};

module.exports = Stepper;